<template><div class="view">

	<main v-if="influencers">

		<div class="influencers-list">
			<div class="influencer"
				v-for="( influencer, influencer_i ) in influencers"
				:key="'in'+influencer_i"
			>	
				<div class="img-holder">
					<div class="img" :style="bg_css(influencer)"></div>
				</div>

				<div class="content wysiwyg-content">

					<div class="name">
						<span class="first">{{influencer.first_name}}</span>
						<span class="last">{{influencer.last_name}}</span>
					</div>
					
					<div class="bio">
						<div class="inner" v-html="influencer.bio_text"></div>
						<div class="fader"></div>
					</div>
					
					<div class="links">
						<a class="link" target="_blank" :href="influencer.instagram_link">Instagram</a>
						<a class="link" v-if="false" target="_blank" :href="influencer.facebook_link">Facebook</a>
					</div>

				</div>

				<router-link :to="'/social/influencer/'+influencer.slug" class="linker"></router-link>

			</div>
		</div>
		
	</main>


</div></template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'
import store from '.././store/store.js'

export default {
	
	mixins: [ mixins.generic ],
	
	components: {
		
	},

	data(){ return {
			

	}},

	computed: {

		influencers(){ return this.$store.state.loaded_influencers },

		category(){ return this.$route.params.category },

		pageTitle(){
			var title = 'Influencers / '
			title += helpers.unslugify(this.category)
			return title
		},

	},

	methods: {


		bg_css(influencer){
			var css = {}
			if( influencer.bio_img_id ) css['background-image'] = 'url('+this.mediaUrl( influencer.bio_img_id, 900 )+')'
			return css
		},

		load_influencers(){

			var _this = this

			this.fetch( 'get_influencers', { category:this.category }, 
			{ onSuccess: function(output){
				
				if( !output.data || !output.data.influencers ) {
					console.log('valid request, but missing data')												
					return
				}

				_this.$store.commit('set_loaded_influencers', output.data.influencers )
				window.prerenderReady = true

			}, onError: function(output){

				console.log('NAH - fetched but with error',output)		

			}})
				
		},

	},
	
	mounted(){
		
		this.load_influencers()		
		this.setDocumentTitle( this.pageTitle )		
		
	},

	watch: {
		
		'$route' (to, from) {
			
			this.load_influencers()
			this.setDocumentTitle( this.pageTitle )
		}	

	},

}
</script>



// WEBPACK FOOTER //
// src/views/InfluencerList.vue